"use client";

import Link from 'next/link';

export function AlaniBanner({ isVisible }: { isVisible: boolean }) {
  return (
    <div
      className={`fixed top-0 left-0 right-0 w-full z-50 bg-[#EA6A54] text-white h-[36px] flex items-center justify-center transform transition-transform duration-300 hidden md:flex ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="flex flex-row items-center justify-center text-center gap-1 sm:gap-2 px-4 flex-wrap w-full">
        <span className="text-xs font-medium">
          Proud supporters of the
        </span>
        <Link
          href="http://alanijonesfoundation.org"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-[#EA6A54] px-3 py-1 rounded hover:bg-white/90 transition-colors mx-1 font-medium font-semibold text-xs"
        >
          Alani Jones Foundation
        </Link>
        <span className="hidden sm:inline text-xs font-medium">—</span>
        <span className="hidden sm:inline text-xs font-medium">
          Supporting families through pregnancy loss and stillbirth
        </span>
      </div>
    </div>
  );
} 